import infiniteScroll from "./dt-infinite-scroll";
import Vue from "vue"

var install=function(Vue){
	Vue.directive("dt-infinite-scroll",infiniteScroll);
}
if(Vue.prototype.$isServer && window.Vue){
	Vue.use(install);
}
export default {install}


// WEBPACK FOOTER //
// ./src/util/dt-infinite-scroll/index.js